import { call, delay, put, select, takeLatest } from "redux-saga/effects";
import { addDBtoSave, adicionaRegistro, changeDBattr, defineAttrDB, registerDB, triggerDBUploader, triggerDbVerification, triggerLoadNovoDB } from "./dbsSlice";
import { server_url } from "../core/config_geral";
import axios from "axios";
import { isNotNull, isNull } from "../helper/functions";
import { generalErrorAction, publicarError } from "../helper/general-error/GeneralErrorSlice";
import { v4 } from "uuid";
import { defineAttr } from "../notetaker/NotetakerSlice";
import md5 from "blueimp-md5";

function* adicionarDBAosRegistros(nome) {

    var token = yield select((state) => state.auth.token)
    var key = yield select((state) => state.dbs.key)

    yield atualizaStatus(true, "Registrando arquivo novo db")
    var payload = {
        remetente: "anano.manager.dbs",
        nome: nome + ".db",
        bucket: "anano.dbs",
        path: "dbs",
        encryptKey: key,
        version: 0
    }

    var formData = new FormData()
    formData.append("file",
        new Blob([JSON.stringify("")], {
            type: "application/json"
        }))
    formData.append("data",
        new Blob([JSON.stringify(payload)], {
            type: "application/json"
        }))

    var r = yield call(() => axios.post(server_url + "/storage", formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }
    }).then(response => response)
        .catch(error => error))

    yield atualizaStatus(false, "Um erro ocorreu...")
    if (r.code == "ERR_NETWORK") {

        yield atualizaStatus(false, "Erro na conexão...")
        yield put(publicarError(generalErrorAction(
            "DbsSaga.registrarArquivoDBNovo",
            isNotNull(r.code) ? r.code : "",
            isNotNull(r.response) ? r.response.status : "",
            isNotNull(r.message) ? r.message : "",
            r
        )))
        return
    }

    if (r.status && r.status == 200) {

        var fId = r.headers.location
        yield put(adicionaRegistro({
            nome: nome,
            fileId: fId
        }))

        yield salvarRegistros()
    }
    // // TODO cuspir erro

}

function* salvarRegistros() {
    var token = yield select((state) => state.auth.token)
    var key = yield select((state) => state.dbs.key)
    var registros = yield select((state) => state.dbs.registros)
    var version = yield select((state) => state.dbs.version)

    yield atualizaStatus(true, "Salvando registros...")
    var payload = {
        remetente: "anano.manager.dbs",
        nome: "dbs.db",
        bucket: "anano.dbs",
        path: "",
        encryptKey: key,
        version: version
    }

    var formData = new FormData()
    formData.append("file",
        new Blob([JSON.stringify(registros)], {
            type: "application/json"
        }))
    formData.append("data",
        new Blob([JSON.stringify(payload)], {
            type: "application/json"
        }))

    var r = yield call(() => axios.post(server_url + "/storage", formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }
    }).then(response => response)
        .catch(error => error))


    if (r.code == "ERR_NETWORK") {

        yield atualizaStatus(false, "Erro na conexão, registros não foram salvos")
        yield put(publicarError(generalErrorAction(
            "DbsSaga.salvarRegistros",
            isNotNull(r.code) ? r.code : "",
            isNotNull(r.response) ? r.response.status : "",
            isNotNull(r.message) ? r.message : "",
            r
        )))
        return
    }

    if (r.status && r.status == 200) {
        yield atualizaStatus(false, "Registros salvos.")
    }
}

function* atualizaStatus(processando, texto) {
    yield put(defineAttrDB({
        campo: "processando",
        value: processando
    }))

    yield put(defineAttrDB({
        campo: "textoProcessamento",
        value: texto
    }))
}

function* loadDBInitialData() {

    // var state = yield select((state) => state)
    // console.log(state)
    var token = yield select((state) => state.auth.token)

    // var payload = {
    //     remetente: "anano.manager.dbs",
    //     nome: "dbs.db",
    //     bucket: "anano.dbs",
    //     path: "",
    //     encryptKey: "ca6aca0f1557ca09283d9ffb6d5c2305",
    //     version: 0
    // }

    // var formData = new FormData()
    // formData.append("file",
    //     new Blob([JSON.stringify([])], {
    //         type: "application/json"
    //     }))
    // formData.append("data",
    //     new Blob([JSON.stringify(payload)], {
    //         type: "application/json"
    //     }))

    // var r = yield call(() => axios.post(server_url + "/storage", formData, {
    //     headers: {
    //         'Content-Type': 'multipart/form-data',
    //         'Authorization': 'Bearer ' + token
    //     }
    // }).then(response => response)
    //     .catch(error => error))


    var fileId = yield select((state) => state.dbs.dbFileId)
    var key = yield select((state) => state.dbs.key)

    yield atualizaStatus(true, "Verificando versao listagem...")

    var r = yield call(() => axios.get(server_url + "/storage/buckets/anano.dbs/arquivos/" + fileId,
        {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(response => response)
        .catch(error => error))

    if (r.code == "ERR_NETWORK") {

        yield atualizaStatus(false, "Erro na conexão...")
        yield put(publicarError(generalErrorAction(
            "DbsSaga.loadDBInitialData",
            isNotNull(r.code) ? r.code : "",
            isNotNull(r.response) ? r.response.status : "",
            isNotNull(r.message) ? r.message : "",
            r
        )))
        return
    }

    var versao = r.data.version

    yield put(defineAttrDB({
        campo: "version",
        value: versao
    }))

    yield atualizaStatus(true, "Versão encontrada: " + versao + ", baixando registros dbs...")

    var r = yield call(() => axios.get(server_url + "/storage/dw/buckets/anano.dbs/arquivos/" + fileId + "/download?access_token=" + token + "&encrypt_key=" + key,).catch(error => error))

    yield atualizaStatus(false, "Concluído")

    if (r.status && r.status == 200) {
        yield put(defineAttrDB({
            campo: "registros",
            value: r.data
        }))
        yield put(defineAttrDB({
            campo: "loaded",
            value: true
        }))

        // localStorage.setItem("tmp_notas", JSON.stringify(r.data))
        yield atualizaStatus(false, "Nada a processar.")
    } else {


        yield atualizaStatus(false, "Não foi possível baixar, verifique a senha.")

        if (r.code == "ERR_NETWORK") {

            yield atualizaStatus(false, "Erro na conexão...")
            yield put(publicarError(generalErrorAction(
                "DbsSaga.loadDBInitialData",
                isNotNull(r.code) ? r.code : "",
                isNotNull(r.response) ? r.response.status : "",
                isNotNull(r.message) ? r.message : "",
                r
            )))

        } else {
            yield atualizaStatus(false, "Erro: alguma coisa aconteceu")
            yield put(publicarError(generalErrorAction(
                "DbsSaga.loadDBInitialData",
                isNotNull(r.code) ? r.code : "",
                isNotNull(r.response) ? r.response.status : "",
                isNotNull(r.message) ? r.message : "",
                r
            )))
        }
    }
}

function* baixarDB(nome) {

    var token = yield select((state) => state.auth.token)
    var key = yield select((state) => state.dbs.key)
    // TODO e se o nome estiver vazio?

    var registros = yield select((state) => state.dbs.registros)

    var regdb = registros.filter(e => e.nome == nome)[0]

    yield atualizaStatus(true, "Procurando versao do banco: " + nome)

    var r = yield call(() => axios.get(server_url + "/storage/buckets/anano.dbs/arquivos/" + regdb.fileId,
        {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(response => response)
        .catch(error => error))

    if (r.code == "ERR_NETWORK") {

        yield atualizaStatus(false, "Erro na conexão...")
        yield put(publicarError(generalErrorAction(
            "DbsSaga.baixarDB",
            isNotNull(r.code) ? r.code : "",
            isNotNull(r.response) ? r.response.status : "",
            isNotNull(r.message) ? r.message : "",
            r
        )))
        return false
    }

    var versao = r.data.version

    yield atualizaStatus(true, "Encontrado, baixando...")

    var r = yield call(() => axios.get(server_url + "/storage/dw/buckets/anano.dbs/arquivos/" + regdb.fileId + "/download?access_token=" + token + "&encrypt_key=" + key,).catch(error => error))

    yield atualizaStatus(false, "Concluído")

    if (r.status && r.status == 200) {

        yield atualizaStatus(false, "DB carregado")
        return {
            version: versao,
            payload: r.data == "" ? null : r.data
        }
    } else {

        yield atualizaStatus(false, "Não foi possível baixar, verifique a senha.")

        if (r.code == "ERR_NETWORK") {

            yield atualizaStatus(false, "Erro na conexão...")
            yield put(publicarError(generalErrorAction(
                "DbsSaga.baixarDB",
                isNotNull(r.code) ? r.code : "",
                isNotNull(r.response) ? r.response.status : "",
                isNotNull(r.message) ? r.message : "",
                r
            )))

        } else {
            yield atualizaStatus(false, "Erro: alguma coisa aconteceu")
            yield put(publicarError(generalErrorAction(
                "DbsSaga.baixarDB",
                isNotNull(r.code) ? r.code : "",
                isNotNull(r.response) ? r.response.status : "",
                isNotNull(r.message) ? r.message : "",
                r
            )))
        }
    }
    return false
}

function* doLoadDB(action) {

    // console.log("Foi?")
    var loaded = yield select((state) => state.dbs.loaded)

    if (!loaded) {
        yield loadDBInitialData()
    }

    var dbs = yield select((state) => state.dbs.dbs)

    // console.log(dbs)

    if(Object.keys(dbs).includes(action.payload.nome)) {
        return
    }

    yield put(registerDB({
        ...action.payload,
        cb: null
    }))
    var registros = yield select((state) => state.dbs.registros)

    if (registros.filter(e => e.nome == action.payload.nome).length == 0) {

        var registros = yield select((state) => state.dbs.registros)

        if (registros.filter(t => t.nome == action.payload.nome).length == 0) {
            var r = yield call(() => adicionarDBAosRegistros(action.payload.nome))
        }
        yield put(changeDBattr({
            nome: action.payload.nome,
            campo: "loaded",
            value: true
        }))
        action.payload.cb(null)

        // console.log("DB Carregado: "+action.payload.nome+ " v: 0")

        return
        // var r = yield call(() => )
    } else {

        var r = yield baixarDB(action.payload.nome)

        if (r) {
            yield put(changeDBattr({
                nome: action.payload.nome,
                campo: "loaded",
                value: true
            }))
            yield put(changeDBattr({
                nome: action.payload.nome,
                campo: "version",
                value: r.version
            }))

            var dbs = (yield select((state) => state.dbs.dbs))
            action.payload.cb(r)
            // console.log("DB Carregado: "+action.payload.nome+ " v: "+r.version)
        } else {
            yield atualizaStatus(false, "Não foi possível baixar o banco do: " + action.payload.nome)
        }

    }


    // Verifica se existe na lista
    // Se nao existe, verifica se estamos com a ultima versao da lista
    // Se nao estamos puxa, e verifica novamente
    // Se estamos, insere e salva

}

function* doDBVerification() {

    var state = yield select((state) => state)
    var dbsKeys = Object.keys(state.dbs.dbs)
    var dbs = state.dbs.dbs

    for (var i = 0; i < dbsKeys.length; i++) {
        var e = dbsKeys[i]
        var hash = md5(JSON.stringify(state[e][dbs[e].atribute]))
        // console.log(JSON.stringify(state[e][dbs[e].atribute]))
        // console.log(hash)
        // console.log(e, hash);
        if (dbs[e].loaded == true) {
            if (dbs[e].modificationId == null) {
                yield put(changeDBattr({
                    nome: e,
                    campo: "modificationId",
                    value: hash
                }))
            } else if (dbs[e].modificationId != hash) {
                yield put(changeDBattr({
                    nome: e,
                    campo: "modificationId",
                    value: hash
                }))
                yield put(addDBtoSave({ e, hash }))
            }
        }
    }

    yield delay(1000)
    yield put(triggerDbVerification())

}

function* salvarDB(dbname) {

    var dbs = yield select((state) => state.dbs.dbs)
    var registros = yield select((state) => state.dbs.registros)

    var db = dbs[dbname]
    var registro = registros.filter(a => a.nome == dbname)[0]
    var targetDB = yield select(state => state[dbname])

    var payload = targetDB[db.atribute]

    // console.log("db", db)
    // console.log("registro", registro)
    // console.log("targetDB", targetDB)
    // console.log("payload", payload)

    var token = yield select((state) => state.auth.token)
    var key = yield select((state) => state.dbs.key)

    yield atualizaStatus(true, "Salvando db: "+dbname)
    var meta = {
        remetente: "anano.manager.dbs",
        nome: dbname + ".db",
        bucket: "anano.dbs",
        path: "dbs",
        encryptKey: key,
        version: db.version
    }

    var formData = new FormData()
    formData.append("file",
        new Blob([JSON.stringify(payload)], {
            type: "application/json"
        }))
    formData.append("data",
        new Blob([JSON.stringify(meta)], {
            type: "application/json"
        }))

    // console.log("DB.Version: ", db.version)

    var r = yield call(() => axios.post(server_url + "/storage", formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }
    }).then(response => response)
        .catch(error => error))

    if (r.code == "ERR_NETWORK") {
        yield atualizaStatus(false, "Erro na conexão...")
        yield put(publicarError(generalErrorAction(
            "DbsSaga.salvarDB",
            isNotNull(r.code) ? r.code : "",
            isNotNull(r.response) ? r.response.status : "",
            isNotNull(r.message) ? r.message : "",
            r
        )))
        return {
            sucesso : false,
            mensgem : "Erro de conexão"
        }
    }

    if (r.status && r.status == 200) {
        yield put(changeDBattr({
            nome : dbname,
            campo : "version",
            value : db.version + 1
        }))
        return {
            sucesso: true,
            mensagem: ""
        }
    } else {
        // console.log(r)
        return {
            sucesso : false,
            mensagem : "Um erro não esperado aconteceu - db: "+dbname
        }
    }

}

function* doDBUploader() {

    var processadas = []

    while (true) {
        // Consulta contador
        // Inicia contagem
        // Terminada contagem
        // Atualiza
        // Encerra 


        var counterInitalValue = 5
        var counter = counterInitalValue
        var dbsToSave = yield select((state) => state.dbs.dbsToSave)
        var length = dbsToSave.length
        var aProcessar = dbsToSave.filter(a => !processadas.includes(a))

        if (aProcessar.length > 0) {
            while (counter > 0) {
                var dbsToSave = yield select((state) => state.dbs.dbsToSave)
                var aProcessar = dbsToSave.filter(a => !processadas.includes(a))

                if (dbsToSave.length > length) {
                    length = dbsToSave.length
                    counter = counterInitalValue
                }
                yield atualizaStatus(true, "Salvando em: " + counter)

                counter--
                yield delay(1000)

            }

            var reduzido = []

            aProcessar.forEach(a => {
                if (!reduzido.includes(a.e)) {
                    reduzido.push(a.e)
                }
            })

            var sucesso = true
            for (var i = 0; i < reduzido.length; i++) {

                var r = yield salvarDB(reduzido[i])

                if (r.sucesso == true) {
                    aProcessar.filter(e => e.e == reduzido[i]).forEach(e => {
                        processadas.push(e)
                    })
                } else {
                    yield atualizaStatus(false, r.mensagem)
                    yield delay(3000)
                    sucesso = false
                }
            }

            if(sucesso) {
                yield atualizaStatus(true, "DBS salvos!")
                yield delay(1000)
                yield atualizaStatus(false, "---")
            } 
        }

        yield delay(1000)
    }
}

export function* listenLoadNovoDB() {
    yield takeLatest(triggerLoadNovoDB, doLoadDB)
}

export function* listenDBVerification() {
    yield takeLatest(triggerDbVerification, doDBVerification)
}

export function* listenDBUploader() {
    yield takeLatest(triggerDBUploader, doDBUploader)
}
